import React, { FC, ReactNode, useMemo } from 'react';
import { type TypographyVariant } from '@mui/material';

import { OfficeDTO } from '@/api/generated';
import TextItemsDisplay from '@/components/TextItemsDisplay/TextItemsDisplay';
import { useOffices } from '@/hooks/useOffices';

const VISIBLE_ITEMS_COUNT = 2;

interface OfficeDisplayProps {
  value?: OfficeDTO[] | string[];
  fallback?: string | ReactNode;
  isArchived?: boolean;
  variant?: TypographyVariant;
}

const OfficeDisplay: FC<OfficeDisplayProps> = ({ variant, value, isArchived, fallback }) => {
  const { offices } = useOffices();
  const officesMap = useMemo(
    () =>
      (offices || []).reduce(
        (acc, item) => ({
          ...acc,
          [item.slug!]: item.name!
        }),
        {} as { [key: string]: string }
      ),
    [offices]
  );
  const items = useMemo(
    () =>
      value?.length
        ? value.map((item: string | OfficeDTO) => (typeof item === 'string' ? officesMap[item] : item.name!))
        : [],
    [value, officesMap]
  );

  return (
    <TextItemsDisplay
      items={items}
      variant={variant}
      visibleItemsCount={VISIBLE_ITEMS_COUNT}
      isArchived={isArchived}
      fallback={fallback}
    />
  );
};

export default OfficeDisplay;
